import React from 'react';

import type { ErrorBoundaryProps } from './ErrorBoundary';
import { ErrorBoundary } from './ErrorBoundary';

type withErrorBoundaryProps<T> = Omit<ErrorBoundaryProps, 'children'> & {
  Component: (props: T) => JSX.Element;
};

export function withErrorBoundary<T>({
  appZone,
  Fallback,
  onError,
  preventRootOnError,
  Component,
}: withErrorBoundaryProps<T>) {
  return (componentProps: T) => {
    return (
      <ErrorBoundary
        appZone={appZone}
        Fallback={Fallback}
        preventRootOnError={preventRootOnError}
        onError={onError}
      >
        {Component(componentProps)}
      </ErrorBoundary>
    );
  };
}
